import { Box, Link, Tabs } from '@nimbus-ds/components';
import { PlanRecommendationResponse } from '@tiendanube/common';
import useTranslationPreOnboarding from 'domains/PreOnboarding/useTranslationPreOnboarding';
import { PlanPageBodyProps } from '../../types';
import { PlanCard } from '../PlanCard/PlanCard';

export function PlanPageBodyMobile({
  plans,
  onPlanSelect,
}: Readonly<PlanPageBodyProps>) {
  const t = useTranslationPreOnboarding('recommendPlan');

  const allPlansOnClik = async () => onPlanSelect('none');

  return (
    <Box>
      <Tabs preSelectedTab={0}>
        {Object.entries(plans).map(
          ([planType, plan]: [string, PlanRecommendationResponse]) => (
            <Tabs.Item key={planType} label={plan.title}>
              <PlanCard
                type={planType}
                title={plan.title}
                price={plan.price}
                description={plan.description}
                features={plan.features}
                buttonText={t(`buttonCta.${planType}`)}
                recommended={planType === 'upgrade'}
                onButtonClick={onPlanSelect}
                showPaymentDisclaimer={planType === 'upgrade'}
              />
            </Tabs.Item>
          ),
        )}
      </Tabs>
      <Box mt="4" display="flex" justifyContent="center">
        <Link
          appearance="primary"
          as="button"
          onClick={allPlansOnClik}
          textDecoration="none"
        >
          {t('allPlans')}
        </Link>
      </Box>
    </Box>
  );
}
